import { sortBy } from 'lodash/fp'
import { MetaList } from '@master/model/common/MetaList'
import { PayeeFullMeta, PayeeFullMetaHeaders } from './PayeeFullMeta'

export class PayeeFullMetaList extends MetaList<PayeeFullMeta> {
  list: PayeeFullMeta[]

  constructor (data: (string | number)[][]) {
    super(PayeeFullMetaHeaders, data, PayeeFullMeta)
    // sort product based on name
    this.list = sortBy((payee) => payee.payeeFullname, this.list)
  }
}
